<template>
	<div id="videocall-frame" ref="videocallFrame"></div>
</template>

<script lang="ts">
	import { defineComponent, onMounted, ref } from "vue";

	export default defineComponent({
		props: {
			callid: String
		},
		setup(props) {
			const videocallFrame = ref(null);

			onMounted(() => {
				const domain = "meet.jit.si";
				const options = {
					roomName: props.callid,
					width: '100%',
					height: '100%',
					parentNode: videocallFrame.value,
					configOverwrite: {
						disableDeepLinking: true
					},
				};

				const jitsi = new (window as any).JitsiMeetExternalAPI(domain, options);
				jitsi.startRecording({});
				//const api = new JitsiMeetExternalAPI(domain, options);
			});

			return { videocallFrame };
		},
	});
</script>